export default "__VITE_ASSET__BOn9xkNb__"